exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-agendar-consulta-js": () => import("./../../../src/pages/agendar-consulta.js" /* webpackChunkName: "component---src-pages-agendar-consulta-js" */),
  "component---src-pages-convenios-js": () => import("./../../../src/pages/convenios.js" /* webpackChunkName: "component---src-pages-convenios-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

